if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindNavigation();
      }

      bindNavigation() {
        if (this.navBound) return;
        this.navBound = true;
        this.querySelector('.product-media-modal__nav--prev')?.addEventListener('click', () => this.step(-1));
        this.querySelector('.product-media-modal__nav--next')?.addEventListener('click', () => this.step(1));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.step(-1);
          if (event.key === 'ArrowRight') this.step(1);
        });
      }

      step(direction) {
        const items = [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
        if (items.length < 2) return;
        const current = Math.max(0, items.findIndex((el) => el.classList.contains('active')));
        const next = items[(current + direction + items.length) % items.length];
        items.forEach((el) => el.classList.remove('active'));
        next.classList.add('active');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
